import { Component, OnInit } from '@angular/core';
import { AqarService } from 'src/app/services/aqar/aqar.service';

@Component({
  selector: 'app-aqar23-c7-seven-three-one',
  templateUrl: './aqar23-c7-seven-three-one.component.html',
  styleUrls: ['./aqar23-c7-seven-three-one.component.scss']
})
export class Aqar23C7SevenThreeOneComponent implements OnInit {
  session: { title: string, link: string }[] = [];
  constructor(private service: AqarService) {
  }

  ngOnInit(): void {
    this.session = this.service.getC731();
  }
}
